import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useLevelStore = defineStore("level", {
  state: () => {
    return {
      levels: [],
    };
  },
});

export const storeLevel = useLevelStore(pinia);
